import { useSnackbar } from "notistack";

export function useMessage() {
  const { enqueueSnackbar } = useSnackbar();

  const showMessage = (
    message = "Hi there! I'm a snackbar message",
    variant = "default",
    options = {
      autoHideDuration: 4000,
      preventDuplicate: true,
    }
  ) => {
    enqueueSnackbar(message, {
      variant,
      ...options,
    });
  };

  const showSuccess = (message, options = {}) => {
    showMessage(message, "success", options);
  };

  const showError = (message, options = {}) => {
    showMessage(message, "error", options);
  };

  const showWarning = (message, options = {}) => {
    showMessage(message, "warning", options);
  };

  const showInfo = (message, options = {}) => {
    showMessage(message, "info", options);
  };

  return {
    showMessage,
    showSuccess,
    showError,
    showWarning,
    showInfo,
  };
}
